import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { Promotion } from 'api/types';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';

async function getPromotion(axios: AxiosInstance, id: number): Promise<Promotion> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/promotion/` + id);
  return data;
}

export default function usePromotionQuery(id?: number) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    queryKey: getKey(id),
    queryFn: () => getPromotion(axios, id!),
    enabled: id != null,
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

export function getKey(id?: number) {
  return ['Promotion', id] as const satisfies QueryKey;
}
usePromotionQuery.getKey = getKey;
